import { useSelector } from 'react-redux';
import { ReducerKeys } from '../../config';
import { ThemesModeEnum } from 'config';
import { IState } from './reducer';
import { StateStatus } from 'redux/utils/common';
import useShallowEqualSelector from 'hooks/useShallowEqualsSelector';

export const useInterest = (): IState['interest'] => {
  return useSelector(
    (state: any) => (state[ReducerKeys.COMMON_REDUCER] as IState).interest
  );
};

export const useGetGlobalSearch = (): IState['globalSearch'] => {
  return useSelector(
    (state: any) => (state[ReducerKeys.COMMON_REDUCER] as IState).globalSearch
  );
};

export interface Customer_NotificationsListElement {
  id: number;
  template: number;
  subject: string;
  body: string;
  email: string;
  notification: string;
  emailrecepient: string;
  customerid: number;
  viewed: number;
  datesend: string;
  url: string;
  web: string;
  avatar: string;
}

interface Customer_NotificationsListData {
  paging: Customer_NotificationsListPaging;
  items: Customer_NotificationsListElement[];
}

interface Customer_NotificationsListPaging {
  page: number;
  pageSize: number;
  total: number;
}

interface Customer_NotificationsistOutput {
  status: StateStatus;
  data: Customer_NotificationsListData | null;
}

export const useGetCustomer_NotificationsList =
  (): Customer_NotificationsistOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.COMMON_REDUCER].Customer_NotificationsList
    );
    return data;
  };
